import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../../../components/public/Footer';

export default function Confidentialite() {
  const [lang, setLang] = useState('En');

  useEffect(() => {
    const syncLang = () => {
      setLang((localStorage.getItem('januslang') || localStorage.getItem('janus_lang')) === 'Fr' ? 'Fr' : 'En');
    };
    syncLang();
    window.addEventListener('langchange', syncLang);
    window.addEventListener('januslangchanged', syncLang);
    return () => {
      window.removeEventListener('langchange', syncLang);
      window.removeEventListener('januslangchanged', syncLang);
    };
  }, []);

  const translations = {
    Fr: {
      metaTitle: "Politique de Confidentialite | Janus Capital Strategy",
      metaDesc: "Politique de confidentialite et protection des donnees personnelles de Janus Capital Strategy.",
      title: "Politique de Confidentialite",
      intro: "Janus Capital Strategy attache une grande importance a la protection de vos donnees personnelles et s'engage a les traiter avec le plus grand soin, dans le respect des reglementations applicables.",
      sections: [
        { h: "Donnees collectees", p: "Nous pouvons collecter des informations telles que votre nom, votre adresse email, votre numero de telephone et toute information que vous nous communiquez volontairement via nos formulaires de contact ou notre prise de rendez-vous." },
        { h: "Finalite du traitement", p: "Vos donnees sont utilisees exclusivement pour repondre a vos demandes, vous fournir nos services de conseil patrimonial et ameliorer la qualite de notre accompagnement." },
        { h: "Conservation des donnees", p: "Vos donnees sont conservees pour une duree n'excedant pas ce qui est necessaire aux finalites pour lesquelles elles sont traitees, dans le respect des obligations legales applicables." },
        { h: "Vos droits", p: "Conformement a la reglementation applicable, vous disposez d'un droit d'acces, de rectification, d'effacement et d'opposition au traitement de vos donnees personnelles. Pour exercer ces droits, vous pouvez nous contacter a l'adresse contact@yemventure.com." },
        { h: "Securite", p: "Janus Capital Strategy met en oeuvre des mesures techniques et organisationnelles appropriees pour proteger vos donnees contre tout acces non autorise, perte ou destruction." }
      ]
    },
    En: {
      metaTitle: "Privacy Policy | Janus Capital Strategy",
      metaDesc: "Privacy policy and personal data protection for Janus Capital Strategy.",
      title: "Privacy Policy",
      intro: "Janus Capital Strategy places great importance on protecting your personal data and is committed to handling it with the utmost care, in compliance with applicable regulations.",
      sections: [
        { h: "Data Collected", p: "We may collect information such as your name, email address, phone number, and any information you voluntarily provide through our contact forms or appointment requests." },
        { h: "Purpose of Processing", p: "Your data is used exclusively to respond to your requests, provide our wealth advisory services, and improve the quality of our support." },
        { h: "Data Retention", p: "Your data is retained for a period not exceeding what is necessary for the purposes for which it is processed, in accordance with applicable legal obligations." },
        { h: "Your Rights", p: "In accordance with applicable regulations, you have the right to access, rectify, erase, and object to the processing of your personal data. To exercise these rights, you may contact us at contact@yemventure.com." },
        { h: "Security", p: "Janus Capital Strategy implements appropriate technical and organizational measures to protect your data against unauthorized access, loss, or destruction." }
      ]
    },
    Ar: {
      metaTitle: "سياسة الخصوصية | جانوس كابيتال ستراتيجي",
      metaDesc: "سياسة الخصوصية وحماية البيانات الشخصية لجانوس كابيتال ستراتيجي.",
      title: "سياسة الخصوصية",
      intro: "تولي جانوس كابيتال ستراتيجي أهمية كبيرة لحماية بياناتكم الشخصية وتلتزم بمعالجتها بأقصى درجات العناية، وفقاً للأنظمة المعمول بها.",
      sections: [
        { h: "البيانات المجمعة", p: "قد نجمع معلومات مثل اسمكم وعنوان بريدكم الإلكتروني ورقم هاتفكم وأي معلومات تقدمونها طوعاً من خلال نماذج التواصل أو طلبات المواعيد." },
        { h: "الغرض من المعالجة", p: "تُستخدم بياناتكم فقط للرد على طلباتكم، وتقديم خدماتنا الاستشارية الثروية، وتحسين جودة مرافقتنا." },
        { h: "الاحتفاظ بالبيانات", p: "يتم الاحتفاظ ببياناتكم لمدة لا تتجاوز ما هو ضروري للأغراض التي تُعالج من أجلها، وفقاً للالتزامات القانونية المعمول بها." },
        { h: "حقوقكم", p: "وفقاً للأنظمة المعمول بها، يحق لكم الوصول إلى بياناتكم وتصحيحها وحذفها والاعتراض على معالجتها. لممارسة هذه الحقوق، يمكنكم التواصل معنا على contact@yemventure.com." },
        { h: "الأمان", p: "تطبق جانوس كابيتال ستراتيجي تدابير تقنية وتنظيمية مناسبة لحماية بياناتكم من الوصول غير المصرح به أو الفقدان أو التدمير." }
      ]
    }
  };

  const t = translations[lang] || translations.En;
  const isRtl = false;

  return (
    <div className="janus-page min-h-screen font-sans" dir={isRtl ? 'rtl' : 'ltr'}>
      <Helmet>
        <title>{t.metaTitle}</title>
        <meta name="description" content={t.metaDesc} />
      </Helmet>
      <section className="pt-40 pb-24 px-6 lg:px-12 max-w-[900px] mx-auto">
        <h1 className="text-3xl md:text-4xl font-light tracking-wide mb-10 janus-title uppercase">{t.title}</h1>
        <div className="space-y-6 janus-text-muted font-light leading-relaxed text-justify">
          <p>{t.intro}</p>
          {t.sections.map((s, i) => (
            <p key={i}><strong>{s.h}</strong><br/>{s.p}</p>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
